@if (shouldShowBanner()) {
  <div class="maintenance-banner" 
       [class.hero-collapsed]="collapsed()" 
       [ngClass]="{
         'top-0': !isImpersonating(),
         'top-[55px]': isImpersonating() && !collapsed(),
         'top-[45px]': isImpersonating() && collapsed()
       }">
    <div class="banner-content">
     
      @if (collapsed()) {
        <div class="banner-message-inline md:text-base text-sm">
          <span [innerHTML]="'maintenanceBanner.message' | translate" [title]="stripHtml('maintenanceBanner.message' | translate)"></span>
        </div>
      } @else {
        <div class="banner-message md:text-base text-sm">
          <p class="message-title font-bold">{{ 'maintenanceBanner.title' | translate }}</p>
          <p class="message-text" [innerHTML]="'maintenanceBanner.message' | translate"></p>
          <p class="message-footer">{{ 'maintenanceBanner.footer' | translate }}</p>
        </div>
      }
      <button class="banner-close" (click)="closeBanner()" aria-label="Close banner">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>
}
